import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { creation } from '@foxitsoftware/foxit-pdf-sdk-for-web-library/lib/PDFViewCtrl';
import { MainDataModels } from 'src/app/models/maindata-models';
import { ObjektDataService } from 'src/app/services/objekt-data.service';
import { SwissSettingsService } from 'src/app/services/swiss-settings.service';

@Component({
  selector: 'app-meine-termine-detail-view',
  templateUrl: './meine-termine-detail-view.component.html',
  styleUrls: ['./meine-termine-detail-view.component.scss'],
})
export class MeineTermineDetailViewComponent implements OnInit{
  public title: string = "";
  public reminder : number = 0;
  public createdBy? : string = '';
  public location : string = '';
  public object : string = "";
  public created : string = "";


  constructor( @Inject(MAT_DIALOG_DATA) public data: MainDataModels.TerminMitBenutzer, public dialogRef: MatDialogRef<MeineTermineDetailViewComponent>, private svcObjektData: ObjektDataService) {}


  ngOnInit(): void {
    this.svcObjektData.getObjektByID(this.data.termin.objectID).subscribe((val) => {
      this.object = val.description
    })
    if(this.data) {
      this.reminder = this.data.termin.reminderNumber;
      this.title = this.data.termin.description;
      this.createdBy = this.data.termin.createdBy;
      this.location = this.data.termin.location;
    }
    if(!(this.data as any).position?.top) {
      this.dialogRef.updatePosition({top: "3.75rem"})
    }
  }

}
